import React from 'react';

export default function ChevronDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="chevron_down"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={props.width ?? '20'}
      height={props.height ?? '20'}
      {...props}
    >
      <path
        id="Vector"
        d="M0,9.467,4.72,4.733,0,0"
        transform="translate(14.732 7.639) rotate(90)"
        fill="none"
        stroke={props.stroke ?? '#1A1A1A'}
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
